import React from "react";
import "./blog.css";
import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import CallToActionSection from "../commonComponent/CallToActionSection";
import { useRef } from "react";
import blogData from "./../blog.json";
import { domainUrl } from "app/Api/axios";
import { Helmet } from "react-helmet";

const HRTechnologyTrendsToWatchOut = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [isactive, setisActive] = useState(null);
  const [blogTitles, setblogTitles] = useState([]);

  useEffect(() => {
    setblogTitles(blogData);
  }, []);

  const sectionRefs = {
    section0: useRef(null),
    section1: useRef(null),
    section2: useRef(null),
    section3: useRef(null),
    section4: useRef(null),
    section5: useRef(null),
    section6: useRef(null),
  };
  const scrollToSection = (section) => {
    const element = sectionRefs[section].current;
    window.scrollTo({
      top: element.offsetTop - 100,
      behavior: "smooth",
    });
  };

  // Scroll event handler to detect which section is in view
  useEffect(() => {
    const handleScroll = () => {
      const sections = Object.keys(sectionRefs); // Get keys (section names)
      let foundActiveSection = "";

      // Check each section to see if it's in the viewport
      sections.forEach((section) => {
        const element = sectionRefs[section].current;
        const rect = element.getBoundingClientRect();

        // If the section is in the viewport (based on top and bottom visibility)
        if (
          rect.top <= window.innerHeight / 2 &&
          rect.bottom >= window.innerHeight / 2
        ) {
          foundActiveSection = section; // Update active section
        }
      });

      if (foundActiveSection !== "") {
        setisActive(foundActiveSection); // Set active section
      }
    };

    // Listen to scroll events
    window.addEventListener("scroll", handleScroll);

    // Cleanup scroll listener
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const listItems = [
    {
      id: "section0",
      label: "Mobile-First HR Technology for On-the-Go Management",
    },
    {
      id: "section1",
      label: "Employee Self-Service Portals for Increased Transparency",
    },
    {
      id: "section2",
      label: "Cloud-Based HR Solutions for Flexibility",
    },
    {
      id: "section3",
      label: "Automation in Attendance and Leave Management",
    },
    {
      id: "section4",
      label: "Data-Driven HR Decisions with Real-Time Analytics",
    },
    {
      id: "section5",
      label: "Why Companies Require HR Technology in 2025",
    },
    {
      id: "section6",
      label: "Conclusion",
    },
  ];

  const location = useLocation();
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "HR Technology Trends to Watch Out for in 2025",
    "image": "https://timetango.in/assets/img/hero/Hero_Combine.png",
    "description":
      "Discover Timetango, India’s leading workforce attendance management system, offering advanced time tracking and productivity software for all businesses.",
    "brand": {
      "@type": "Brand",
      "name": "Time Tango",
      "logo": "https://timetango.in/assets/logo3.svg",
      "sameAs": [
        "https://www.facebook.com/people/TimeTango/61550584126267/",
        "https://www.linkedin.com/showcase/99884387/",
        "https://www.instagram.com/timetango.in/",
      ],
    },
    "offers": {
      "@type": "Offer",
      "url": "https://timetango.in",
      "priceCurrency": "INR",
      "price": "30",
    },
  };
  const canonicalURL = `${domainUrl}${location.pathname}`;

  return (
    <>
      <Helmet>
        <title>HR Technology Trends to Watch Out for in 2025</title>
        <meta
          name="description"
          content="Track employee attendance with Time Tango’s efficient and user-friendly time tracking & activity tracking software. Simplify HR management today with additional feature as Leave management system."
        />
        <meta
          property="og:title"
          content="HR Technology Trends to Watch Out for in 2025"
        />
        <meta
          property="og:description"
          content="Track employee attendance with Time Tango’s efficient and user-friendly time tracking & activity tracking software. Simplify HR management today with additional feature as Leave management system."
        />
        <meta
          property="og:image"
          content="https://timetango.in/assets/logo3.svg"
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={canonicalURL} />
        <link rel="canonical" href={canonicalURL} />
        <meta property="og:site_name" content="Timetango" />
        <meta name="language" content="english" />
        <meta name="robots" content="index, follow" />
        <meta
          name="google-site-verification"
          content="HeqJ8arMIZIDpCmRH1zlrNu601VS7Wp92JoTy_9bARM"
        ></meta>
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>

      <section className="w-100 bccolor heights">
        <div className="text-center fs-18 mb-3">
          <Link to={"/blogs"}>Blog</Link>/HR Technology Trends to Watch Out for
          in 2025
        </div>
        <h1 className="text-center mb-5 ">
        HR Technology Trends to Watch Out for in 2025
        </h1>
      </section>
      {/* component 2 */}
      <section
        className="p-20 "
        style={{ paddingTop: "50px", paddingBottom: "50px" }}
      >
        <div className="row w-100 justify-content-center gap-2">
          <div className="col-3 card-blog hidden" style={{ height: "450px" }}>
            <ul className="p-2 mt-3 mb-3 ulist" style={{ cursor: "pointer" }}>
              {listItems.map((item, index) => (
                <li
                  key={index}
                  className={`p-1 ${isactive === item.id ? "active" : null}`}
                  onClick={() => {
                    scrollToSection(item.id);
                  }}
                >
                  {item.label}
                </li>
              ))}
            </ul>
          </div>
          <div className="col-12 col-md-12 col-lg-7 ">
            <div className="mb-4">
              <p className="fs-16-js mb-4">
                As the nature of business continues to change, so does HR. HR
                technology will be vital in automating workforce management,
                employee experience, and making work more efficient in 2025.
                Firms are abandoning their old HR methods in favor of digital
                means of saving time and eliminating tedious labor.
              </p>
              <p className="fs-16-js mb-4">
                One of the most important areas of change is time tracking and
                attendance. Solutions such as <b>TimeTango</b>, a sophisticated{" "}
                <b>HR attendance management</b> software, enable companies to
                monitor work hours of employees, track leaves, and maximize
                workforce productivity.
              </p>
              <p className="fs-16-js mb-4">
                In this blog, we will see what are the top HR tech trends in
                2025 and how they are influencing the future of workforce
                management.
              </p>
            </div>

            {/* component */}
            <div className="mb-4 " ref={sectionRefs.section0}>
              <h2 className="fs-3 fw-bold">
                1. Mobile-First HR Technology for On-the-Go Management
              </h2>
              <p className="fs-16-js">
                As mobile technology is now a part of business operations, HR
                tools need to be mobile-enabled. An{" "}
                <Link
                  to="/real-time-insight"
                  className="text-decoration-none fw-bold"
                >
                  employee time tracking mobile app with real-time data
                </Link>{" "}
                enables employees to mark attendance, monitor work hours, and
                apply for leaves from their mobile phones.
              </p>
              <p className="fs-16-js">
                Major advantages of mobile HR solutions:
              </p>

              <ul className="custom-dot-list">
                <li>Employees can clock in/out remotely</li>
                <li>Managers can monitor attendance on the move</li>
                <li>Real-time notifications for approvals and updates</li>
              </ul>

              <p className="fs-16-js">
                TimeTango has a real-time employee time tracking functionality
                via its mobile-responsive interface so that companies can manage
                attendance with ease from any location.
              </p>
            </div>

            {/* component */}
            <div className="mb-4 " ref={sectionRefs.section1}>
              <h2 className="fs-3 fw-bold">
                2. Employee Self-Service Portals for Increased Transparency
              </h2>
              <p className="fs-16-js">
                Self-service HR portals will be even more critical in 2025.
                These enable employees to:
              </p>

              <ul className="custom-dot-list">
                <li>Check their attendance</li>
                <li>Request leaves</li>
                <li>Review their work schedule</li>
                <li>Look at past attendance records</li>
              </ul>
              <p className="fs-16-js">
                With an {" "}
                                <Link
                                  to="/leave-mangement"
                                  className="text-decoration-none fw-bold"
                                >
                                  attendance and leave management software
                                </Link>{" "}, like
                TimeTango, workers can monitor work hours and leave management
                without relying on HR teams, lessening workload and improving
                transparency.
              </p>
            </div>

            {/* component */}
            <div className="mb-4 " ref={sectionRefs.section2}>
              <h2 className="fs-3 fw-bold">
                3. Cloud-Based HR Solutions for Flexibility
              </h2>
              <p className="fs-16-js">
                Cloud technology is transforming HR operations. Companies are
                abandoning paper-based and on-premise software in favor of
                cloud-based solutions. These provide:
              </p>

              <ul className="custom-dot-list">
                <li>Access to HR information remotely from anywhere</li>
                <li>Improved security and data backup</li>
                <li>Smooth integration with other HR tools</li>
              </ul>
              <p className="fs-16-js">
                A effective <b>time and attendance management system</b>, such as
                TimeTango, enables companies to monitor employee leaves and
                attendance from anywhere, and hence it is the ideal solution for
                distributed and hybrid workplaces.
              </p>
            </div>

            {/* component */}
            <div className="mb-4 " ref={sectionRefs.section3}>
              <h2 className="fs-3 fw-bold">
                4. Automation in Attendance and Leave Management
              </h2>
              <p className="fs-16-js">
                Manual HR work consumes too much time. Automating attendance and
                leave management can really boost efficiency. <b>HR attendance
                management software</b> now includes automated options like:
              </p>

              <ul className="custom-dot-list">
                <li>Auto-calculation of working hours </li>
                <li>Auto-approval of leaves as per company rules </li>
                <li>Immediate alerts for late entry or absence</li>
              </ul>
              <p className="fs-16-js">
                By using an {" "}
                                <Link
                                  to="/leave-mangement"
                                  className="text-decoration-none fw-bold"
                                >
                                 attendance and leave management software
                                </Link>{" "}, businesses
                can eliminate manual errors and ensure smooth workforce
                management.
              </p>
            </div>

            {/* component */}
            <div className="mb-4 " ref={sectionRefs.section4}>
              <h2 className="fs-3 fw-bold">
                5. Data-Driven HR Decisions with Real-Time Analytics
              </h2>
              <p className="fs-16-js">
                HR teams need real-time insights to make informed decisions. An
                advanced time and attendance management system provides
              </p>

              <ul className="custom-dot-list">
                <li>Employee attendance trends </li>
                <li>Overtime and productivity analysis </li>
                <li>Absenteeism reports</li>
              </ul>
              <p className="fs-16-js">
                A real-time employee time tracking software such as TimeTango
                assists companies in monitoring attendance trends and
                streamlining workforce scheduling efficiently.
              </p>
            </div>

            {/* component */}
            <div className="mb-4 " ref={sectionRefs.section5}>
              <h2 className="fs-3  fw-bold">
                Why Companies Require HR Technology in 2025
              </h2>
              <ul className="custom-dot-list">
                <li>
                  <b>Saves Time</b> – Automates mundane HR procedures, enabling
                  HR teams to direct their time to strategic initiatives.{" "}
                </li>
                <li>
                  <b>Increases Accuracy</b> – Deploys machines rather than
                  humans to reduce errors in attendance and leave tracking.
                </li>
                <li>
                  <b>Streamlines Employee Experience</b> – Offers transparency
                  and employee self-service.
                </li>
                <li>
                  <b>Compliance</b> – Keeps accurate records for legal and
                  regulatory compliance.
                </li>
              </ul>
            </div>

            {/* component */}
            <div className="mb-4" ref={sectionRefs.section6}>
              <h2 className="fs-3 fw-bold">Conclusion</h2>
              <p className="fs-16-js">
                HR technology is moving fast, and companies that use digital
                solutions will remain ahead of the curve in 2025. From
                cloud-based HR administration to mobile HR attendance tracking
                and real-time analysis, the proper technology can significantly
                enhance workforce productivity.
              </p>
              <p className="fs-16-js">
                With TimeTango {" "}
                                <Link
                                  to="/leave-mangement"
                                  className="text-decoration-none fw-bold"
                                >
                                 attendance and leave management software
                                </Link>, companies can
                simplify attendance tracking, leave management, and employee
                work schedule optimization. By utilizing real-time employee time
                tracking or a cutting-edge time and attendance management
                system, companies can automate HR processes and improve
                productivity.
              </p>
              <p className="fs-16-js">
                Leap into the latest HR technology innovations and elevate your
                workforce management to the next level with TimeTango!
              </p>
            </div>
          </div>
          <div
            className="col-3 hidden"
            style={{
              maxHeight: "100vw",
              overflowY: "auto",
              scrollbarWidth: "none",
              position: "sticky",
              top: 0,
            }}
          >
            <p className="text-center fs-18 fw-bold">Recent blog</p>
            <div className="d-flex justify-content-center flex-column gap-4">
              {blogTitles?.map((item, index) => (
                <div key={index} className="card-sub-blog">
                  <div>
                    <Link to={item.link}>
                      <img
                        src={item.img}
                        alt={item.alt}
                        className="w-100 h-100"
                      />
                    </Link>
                  </div>
                  <div className="px-2">
                    <Link to={item.link}>
                      <p className="text-justify fs-12 mb-0"> {item.title}</p>
                      <div className="py-2">
                        <button className="btn btn-link p-0 fs-12">
                          Continue reading <span>&rarr;</span>
                        </button>
                      </div>
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      {/* componnent 2 */}
      <CallToActionSection></CallToActionSection>
    </>
  );
};

export default HRTechnologyTrendsToWatchOut;
